export const environment = {
    production: false,
    apiBaseUrl: '/api',
    auth: {
        loginPath: '/auth/entra/redirect',
        callbackPath: '/auth/entra/callback',
        refreshPath: '/auth/entra/refresh',
        logoutPath: '/auth/entra/logout',
        postLogoutRedirect: '/'
    },
    oauth: {
        issuer: '',
        scope: 'openid profile email User.Read',
        responseType: 'code'
    }
};
